import React from 'react'
import PropTypes from "prop-types"
import { StaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import { withPreview } from '@prismicio/gatsby-source-prismic-graphql';
import get from 'lodash/get';

import { CONTENT_TYPES } from './seo.constants';

import { getPathFromMeta } from '../../utils/link'
import { getSchema } from '../../utils/schema'

// const SEO = (props) => {
// 	const shareImage = props.pageShareImage || props.siteShareImage;
// 	const schema = getSchema(props);

// 	return (
// 		<Helmet title={props.pageTitle ? `${props.pageTitle} | ${props.siteTitle}` : props.siteTitle}>
// 			<html lang={props.language} dir={props.siteDirection} />

// 			<link rel="alternate" href={`${props.siteURL}${props.pagePath}`} hrefLang={props.language} />
// 			{props.alternateLanguages && props.alternateLanguages.map((alternate) => (
// 				<link rel="alternate" href={`${props.siteURL}${alternate.path}`} hrefLang={alternate.language} key={alternate.language} />
// 			))}

// 			{props.pageDescription && <meta name="description" content={props.pageDescription} />}

// 			<link rel="canonical" href={`${props.siteURL}${props.pagePath}`} />
			
// 			<meta property="og:title" content={props.pageTitle ? `${props.siteTitle} | ${props.pageTitle}` : props.siteTitle} />
// 			<meta property="og:type" content="website" />
// 			{props.pageDescription && <meta property="og:description" content={props.pageDescription} />}
// 			<meta property="og:site_name" content={props.siteName} />
// 			<meta property="og:url" content={`${props.siteURL}${props.pagePath}`} />
			
// 			{shareImage && <meta property="og:image" content={`${shareImage.url}`} />}
// 			<meta property="og:image:width" content="1200" />
// 			<meta property="og:image:height" content="630" />
// 			<meta name="twitter:card" content={"summary_large_image"} />
// 			{props.twitterUsername && <meta name="twitter:site" content={`@${props.twitterUsername}`} />}

// 			{schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}

// 			<script type="text/javascript">{`
// 			window.addEventListener('onBitrixLiveChat', function(event){
// 				window.__widget = event.detail.widget;
// 			});
// 			`}</script>
// 		</Helmet>
// 	)
// }

// export default SEO;








const seoQuery = graphql`
query {
	site {
		siteMetadata {
			siteUrl
			defaultLanguage
    		includeDraftLanguages
		}
	}
	prismic {
		allConfigurations {
			edges {
				node {
					_meta{
						lang
					}
					live
				}
			}
		}
		
	}
}
`;

const SEO = (props) => {
	
	return (
		<StaticQuery
			query={`${seoQuery}`}
			render={withPreview(data => {
				
				const site = get(data,"site.siteMetadata");
				const configurations = get(data,"prismic.allConfigurations.edges",[]).map(edge => edge.node);
				const configuration = configurations.find(node => node._meta.lang === props.language);

				const alternates = props.alternateLanguages ? props.alternateLanguages.filter(alternate => configurations.find(configuration => configuration._meta.lang === alternate.language && (site.includeDraftLanguages || configuration.live))) : [];

				const shareImage = props.pageShareImage || props.siteShareImage;
				const schema = getSchema(props);

				return (
					<Helmet title={props.pageTitle ? `${props.pageTitle} | ${props.siteTitle}` : props.siteTitle}>
						<html lang={props.language} dir={props.siteDirection} />

						<link rel="alternate" href={`${props.siteURL}${props.pagePath}`} hrefLang={props.language === site.defaultLanguage ? 'x-default' : props.language} />
						{alternates.map((alternate) => (
							<link rel="alternate" href={`${props.siteURL}${alternate.path}`} hrefLang={alternate.language === site.defaultLanguage ? 'x-default' : alternate.language} key={alternate.language} />
						))}

						{props.pageDescription && <meta name="description" content={props.pageDescription} />}

						<link rel="canonical" href={`${props.siteURL}${props.pagePath}`} />
						
						<meta property="og:title" content={props.pageTitle ? `${props.siteTitle} | ${props.pageTitle}` : props.siteTitle} />
						<meta property="og:type" content="website" />
						{props.pageDescription && <meta property="og:description" content={props.pageDescription} />}
						<meta property="og:site_name" content={props.siteName} />
						<meta property="og:url" content={`${props.siteURL}${props.pagePath}`} />
						
						{shareImage && <meta property="og:image" content={`${shareImage.url}`} />}
						<meta property="og:image:width" content="1200" />
						<meta property="og:image:height" content="630" />
						<meta name="twitter:card" content={"summary_large_image"} />
						{props.twitterUsername && <meta name="twitter:site" content={`@${props.twitterUsername}`} />}

						{schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}

						<script type="text/javascript">{`
						window.addEventListener('onBitrixLiveChat', function(event){
							window.__widget = event.detail.widget;
						});
						`}</script>
					</Helmet>
				)

			}, seoQuery)}
		/>
	)
};

export default SEO;


